import React from 'react';

function Heading2({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 3 6, v 12" />
      <path d="M 3.5 12, h 8" />
      <path d="M 12 6, v 12" />
      <path d="M16.5 12.5C16.5 11 17.5 10.5 18.5 10.5C20 10.5 21 12 19.5 14" />
      <path d="M 19.5 14, l -3 4" />
      <path d="M 16.5 18, h 4" />
    </svg>
  );
}

export default Heading2;
